import { createContext, useContext } from 'react';
import type { ViewerProvider } from './types';
import { getDefaultViewer } from './viewerRegistry';

const ViewerContext = createContext<ViewerProvider>(getDefaultViewer());

export const ViewerContextProvider = ViewerContext.Provider;

/** Get the active viewer provider from context */
export function useViewerProvider(): ViewerProvider {
  return useContext(ViewerContext);
}
